module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "panel-body"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f172a5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/panels/Body.vue
// module id = 671
// module chunks = 1